// @module BluePoint.SegregateItems.SegregateItems
define('BluePoint.SegregateItems.SegregateItems.View'
,	[
		'bluepoint_segregateitems_segregateitems.tpl'
	
	,	'BluePoint.SegregateItems.SegregateItems.SS2Model'
	
	,	'Backbone'
    ]
, function (
		bluepoint_segregateitems_segregateitems_tpl
	
	,	SegregateItemsSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class BluePoint.SegregateItems.SegregateItems.View @extends Backbone.View
	return Backbone.View.extend({

		template: bluepoint_segregateitems_segregateitems_tpl

	,	initialize: function (options) {
			// this.model = new SegregateItemsModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {
		}

		//@method getContext @return BluePoint.SegregateItems.SegregateItems.View.Context
	,	getContext: function getContext()
		{
			//@class BluePoint.SegregateItems.SegregateItems.View.Context
			return {
			};
		}
	});
});
